import React,{Component} from 'react'
import FontAwesome from 'react-fontawesome'
import { Box } from 'reactjs-admin-lte'
import { Button, Tabs, Tab, FormGroup, Form, Col, FormControl } from 'react-bootstrap'
import { Radio } from 'react-icheck'
import DatePicker from 'component/element/DatePicker'
// import { format } from 'url';
import InputNumber from 'rc-input-number'
import TyreStore from 'stores/TyreStore';
import ConfirmPopup from 'component/element/ConfirmPopup'
import Moment from 'moment';
import CkTimePicker from 'component/element/CkTimePicker'
import IframeModal from 'component/element/IframeModal'
const NotificationSystem = require('react-notification-system')
const TODAY = Moment().format('L').replace(Moment().format('YYYY'), (Moment().format('YYYY')*1) + 543)
const TIME =  Moment().format('h:mm:ss')
class AssetVehicleOperation extends Component {
    constructor(props) {
      super(props)

      this.state = {
        vehicle_id:'',  
        work_no:'',
        data:[],
        tyreChangeActiveKey:0,
        tyreSwap:[],
        tyreChange:[],
        tyreRepair:[],
        treaddepth:[],
        form:{record_date:TODAY,record_time:TIME,description:'',request_by:'',response_by:'',tyre_mileage:''},
        isView:false,
        valid:{change:[],repair:[],depth:[]},
        isSave:true,
        stocklist:[],
        showChangeConfirm:false,
        isStocklist:false,
        showCancelConfirm:false,
        record_id:undefined
      }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
        this._iframe = this.refs.iframe
    }

    componentWillReceiveProps(newProps) { 
        if (newProps.showOpt&&newProps.showOpt!==this.props.showOpt) {
            this.setState({isView:false,data:newProps.data,work_no:newProps.work_no,vehicle_id:newProps.vehicle_id})
        }
    }

    setIsView(mode,items) {
        let {tyreChange,tyreRepair,treaddepth,tyreSwap,form} = this.state
        if (mode==='swap')
            tyreSwap = items.items
        else if (mode==='replace')
            tyreChange = items.items
        else if (mode==='repair')    
            tyreRepair = items.items
        else if (mode==='treaddepth')    
            treaddepth = items.items
        
        form = items.meta
        form.record_date = items.meta.record_date
        form.record_time = items.meta.record_time
        this.setState({record_id:items.meta.tyre_record_id,isView:true,form:form,tyreChange:tyreChange,tyreRepair:tyreRepair,treaddepth:treaddepth,tyreSwap:tyreSwap})
    }

    setTabActiveKey(key) {
        this.setState({tyreChangeActiveKey:key*1})
    }

    setTreadDepth(treadDepthPartPositions) {
        let treaddepth = []
        treadDepthPartPositions.forEach((item,index)=>{
            if (item.status) {
                treaddepth.push({
                    wheel_at:item.label,
                    serial_no:item.doc.serial_no,
                    tyre_code:item.doc.tyre_code,
                    tyre_brand:item.doc.tyre_brand,
                    tyre_model:item.doc.tyre_model,
                    tyre_size:item.doc.tyre_size,
                    treaddepth:item.doc.treaddepth
                })
            }    
        })
        this.setState({treaddepth:treaddepth})
    }

    setTyreChange(tyreChangePartPositions) {
        let tyreChange = []
        let stocklist = []
        tyreChangePartPositions.forEach((item,index)=>{
            if (item.status) {
                tyreChange.push({
                    wheel_at:item.label,
                    serial_no:'',
                    tyre_code:'',
                    tyre_brand:'',
                    tyre_model:'',
                    tyre_size:'',
                    tyre_mileage:'',
                    is_new:''
                })
                stocklist.push({
                    wheel_at:item.label,
                    serial_no:item.doc.serial_no===undefined?'':item.doc.serial_no,
                    tyre_code:item.doc.tyre_code,
                    tyre_brand:item.doc.tyre_brand,
                    tyre_model:item.doc.tyre_model,
                    tyre_size:item.doc.tyre_size,
                    tyre_mileage:'',
                    is_new:item.doc.is_new
                })
            }    
        })
        this.setState({tyreChange:tyreChange,stocklist:stocklist})
    }

    setTyreRepair(tyreRepairPartPositions) {
        let tyreRepair = []
        tyreRepairPartPositions.forEach((item,index)=>{
            if (item.status) {
                tyreRepair.push({
                    wheel_at:item.label,
                    serial_no:item.doc.serial_no,
                    tyre_code:item.doc.tyre_code,
                    tyre_brand:item.doc.tyre_brand,
                    description:item.doc.description,
                    tyre_size:item.doc.tyre_size,
                    shop_name:item.doc.shop_name
                })
            }    
        })
        this.setState({tyreRepair:tyreRepair})
    }

    onSaveClick() {
        let {tyreChangeActiveKey} = this.state
        if (tyreChangeActiveKey===1) {
            this.setState({showChangeConfirm:true})
        } else {
            this.setState({showConfirm:true})
        }
    }

    onStocklistClick(value) {
        this.setState({isStocklist:value})
        setTimeout(()=>{
            this.setState({showConfirm:true,showChangeConfirm:false})
        },100)
    }

    onOperationSave(){
        let {partPositions,hasHead,hasTail} = this.props
        let {tyreChangeActiveKey,form,data,vehicle_id,work_no,tyreChange,treaddepth,tyreRepair,valid,isSave,isStocklist,stocklist} = this.state
        if (isSave) {
            this.setState({isSave:false,valid_date:false})
            if (form.record_date===''||form.record_date===undefined||form.record_date===null) {
                this._notificationSystem.addNotification({
                    title:'แจ้งเตือน',
                    message: 'กรุณาเลือกวันที่',
                    level: 'error',
                    position:'tc'
                });
                this.setState({isSave:true,valid_date:true,showConfirm:false,isStocklist:false})
                return false
            }
            if (tyreChangeActiveKey===0) {
                let items = partPositions.reduce((rresult,item,index)=>{
                    let postData = {vehicle_id:vehicle_id,swap_date:form.record_date,record_time:form.record_time,description:form.description,request_by:form.request_by,response_by:form.response_by,from_wheel_at:item.label,to_wheel_at:item.new_position,serial_no:'',tyre_brand:'',tyre_code:'',is_new:'',tyre_size:'',tyre_mileage:''}
                    if(item.new_position!==false){
                        const key = data.findIndex(x=>x.wheel_at===item.new_position)
                        if (key!==-1) {
                            postData.serial_no = data[key].serial_no
                            postData.tyre_brand = data[key].tyre_brand
                            postData.tyre_code = data[key].tyre_code
                            postData.tyre_model = data[key].tyre_model
                            postData.is_new = data[key].is_new
                            postData.tyre_size = data[key].tyre_size
                            postData.tyre_mileage = data[key].tyre_mileage
                        }
                        rresult.push(postData)
                    }    
                    return rresult
                },[])
                if (items.length===0) {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'ไม่พบข้อมูลรายการสลับยาง',
                        level: 'error',
                        position:'tc'
                    });
                    this.setState({showConfirm:false,isStocklist:false,isSave:true})
                } else {
                    let postData = {meta:{record_date:form.record_date,record_time:form.record_time,work_no:work_no,has_head:hasHead,has_tail:hasTail,request_by:form.request_by,response_by:form.response_by,description:form.description,tyre_mileage:form.tyre_mileage},data:items}
                    TyreStore.saveAssetVehicleSwap(vehicle_id,postData,(result)=>{
                        if (result.status==='OK') {
                            this._notificationSystem.addNotification({
                                title:'แจ้งเตือน',
                                message: 'บันทึกรายการสลับยางสำเร็จ',
                                level: 'info',
                                position:'tc'
                            });
                            this.props.onReload()
                            setTimeout(()=>{
                                this.props.normalMode()
                            },800)
                            this.setState({showConfirm:false,isStocklist:false,isSave:true})
                        }
                    },()=>{
                        this._notificationSystem.addNotification({
                            title:'แจ้งเตือน',
                            message: 'ไม่สามารถบันทึกรายการสลับยางได้',
                            level: 'error',
                            position:'tc'
                        });
                        this.props.onReload()
                        setTimeout(()=>{
                            this.props.normalMode()
                        },800)
                        this.setState({showConfirm:false,isStocklist:false,isSave:true})
                    })
                }    
            } else if (tyreChangeActiveKey===1) {
                let items = []
                let _valid = []
                tyreChange.forEach((item,index)=>{
                    let postData = {vehicle_id:vehicle_id,replace_date:form.record_date,record_time:form.record_time,description:form.description,request_by:form.request_by,response_by:form.response_by,wheel_at:'',serial_no:'',tyre_brand:'',tyre_code:'',is_new:'',tyre_size:'',tyre_mileage:''}
                    postData.wheel_at = item.wheel_at
                    postData.serial_no = item.serial_no
                    postData.tyre_brand = item.tyre_brand
                    postData.tyre_model = item.tyre_model
                    postData.tyre_code = item.tyre_code
                    postData.is_new = item.is_new
                    postData.tyre_size = item.tyre_size
                    postData.tyre_mileage = item.tyre_mileage
                    items.push(postData)
                    if (item.serial_no===''||item.serial_no===undefined||item.serial_no===null) {
                        _valid.push(index)
                    }
                })
                if (_valid.length>0) {
                    valid.change = _valid
                    this.setState({showConfirm:false,isStocklist:false,valid:valid,isSave:true})
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'กรุณากรอกหมายเลขยาง',
                        level: 'error',
                        position:'tc'
                    });
                    return false
                } else if (items.length===0) {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'ไม่พบข้อมูลรายการเปลี่ยนยาง',
                        level: 'error',
                        position:'tc'
                    });
                    this.setState({showConfirm:false,isStocklist:false,isSave:true})
                } else {
                    valid.change = []
                    let postData = {meta:{record_date:form.record_date,record_time:form.record_time,work_no:work_no,has_head:hasHead,has_tail:hasTail,request_by:form.request_by,response_by:form.response_by,description:form.description,tyre_mileage:form.tyre_mileage},data:items,stocklist:(isStocklist?stocklist:[])}
                    TyreStore.saveAssetVehicleReplace(vehicle_id,postData,(result)=>{
                        if (result.status==='OK') {
                            this._notificationSystem.addNotification({
                                title:'แจ้งเตือน',
                                message: 'บันทึกรายการเปลี่ยนยางสำเร็จ',
                                level: 'info',
                                position:'tc'
                            });
                            this.props.onReload()
                            setTimeout(()=>{
                                this.props.normalMode()
                            },800)
                            this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                        }
                    },()=>{
                        this._notificationSystem.addNotification({
                            title:'แจ้งเตือน',
                            message: 'ไม่สามารถบันทึกรายการเปลี่ยนยางได้',
                            level: 'error',
                            position:'tc'
                        });
                        this.props.onReload()
                        setTimeout(()=>{
                            this.props.normalMode()
                        },800)
                        this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                    })
                }    
            } else if (tyreChangeActiveKey===3) {
                let items = []
                let _valid = []
                treaddepth.forEach((item,index)=>{
                    item = Object.assign({serial_no:'',tyre_mileage:''},item)
                    items.push(item)
                    if (item.serial_no===''||item.serial_no===undefined||item.serial_no===null) {
                        _valid.push(index)
                    }
                })
                if (_valid.length>0) {
                    valid.depth = _valid
                    this.setState({showConfirm:false,isStocklist:false,valid:valid,isSave:true})
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'กรุณากรอกหมายเลขยาง',
                        level: 'error',
                        position:'tc'
                    });
                    return false
                } else if (items.length===0) {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'ไม่พบข้อมูลรายการวัดยาง',
                        level: 'error',
                        position:'tc'
                    });
                    this.setState({showConfirm:false,isStocklist:false,isSave:true})
                } else {
                    valid.depth = []
                    let postData = {meta:{record_date:form.record_date,record_time:form.record_time,work_no:work_no,has_head:hasHead,has_tail:hasTail,request_by:form.request_by,response_by:form.response_by,description:form.description,tyre_mileage:form.tyre_mileage},data:items}
                    TyreStore.saveAssetVehicleTreadDepth(vehicle_id,postData,(result)=>{
                        if (result.status==='OK') {
                            this._notificationSystem.addNotification({
                                title:'แจ้งเตือน',
                                message: 'บันทึกรายการวัดดอกยางสำเร็จ',
                                level: 'info',
                                position:'tc'
                            });
                            this.props.onReload()
                            setTimeout(()=>{
                                this.props.normalMode()
                            },800)
                            this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                        }
                    },()=>{
                        this._notificationSystem.addNotification({
                            title:'แจ้งเตือน',
                            message: 'ไม่สามารถบันทึกรายการวัดดอกยางได้',
                            level: 'error',
                            position:'tc'
                        });
                        this.props.onReload()
                        setTimeout(()=>{
                            this.props.normalMode()
                        },800)
                        this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                    })
                }    
            } else if (tyreChangeActiveKey===4) {
                let items = []
                let _valid = []
                tyreRepair.forEach((item,index)=>{
                    let postData = {vehicle_id:vehicle_id,replace_date:form.record_date,record_time:form.record_time,description:form.description,request_by:form.request_by,response_by:form.response_by,wheel_at:'',serial_no:'',tyre_brand:'',tyre_code:'',is_new:'',tyre_size:'',tyre_mileage:'',detail:'',shop_name:''}
                    postData.wheel_at = item.wheel_at
                    postData.serial_no = item.serial_no
                    postData.tyre_brand = item.tyre_brand
                    postData.tyre_model = item.tyre_model===undefined?'':item.tyre_model
                    postData.tyre_code = item.tyre_code
                    postData.detail = item.description
                    postData.shop_name = item.shop_name
                    postData.tyre_size = item.tyre_size
                    items.push(postData)
                    if (item.serial_no===''||item.serial_no===undefined||item.serial_no===null) {
                        _valid.push(index)
                    }
                })
                if (_valid.length>0) {
                    valid.repair = _valid
                    this.setState({showConfirm:false,isStocklist:false,valid:valid,isSave:true})
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'กรุณากรอกหมายเลขยาง',
                        level: 'error',
                        position:'tc'
                    });
                    return false
                } else if (items.length===0) {
                    this._notificationSystem.addNotification({
                        title:'แจ้งเตือน',
                        message: 'ไม่พบข้อมูลรายการซ่อมยาง',
                        level: 'error',
                        position:'tc'
                    });
                    this.setState({showConfirm:false,isStocklist:false,isSave:true})
                } else {
                    valid.repair = []
                    let postData = {meta:{record_date:form.record_date,record_time:form.record_time,work_no:work_no,has_head:hasHead,has_tail:hasTail,request_by:form.request_by,response_by:form.response_by,description:form.description,tyre_mileage:form.tyre_mileage},data:items}
                    TyreStore.saveAssetVehicleRepair(vehicle_id,postData,(result)=>{
                        if (result.status==='OK') {
                            this._notificationSystem.addNotification({
                                title:'แจ้งเตือน',
                                message: 'บันทึกรายการซ่อมยางสำเร็จ',
                                level: 'info',
                                position:'tc'
                            });
                            this.props.onReload()
                            setTimeout(()=>{
                                this.props.normalMode()
                            },800)
                            this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                        }
                    },()=>{
                        this._notificationSystem.addNotification({
                            title:'แจ้งเตือน',
                            message: 'ไม่สามารถบันทึกรายการซ่อมยางได้',
                            level: 'error',
                            position:'tc'
                        });
                        this.props.onReload()
                        setTimeout(()=>{
                            this.props.normalMode()
                        },800)
                        this.setState({isSave:true,valid:valid,showConfirm:false,isStocklist:false})
                    })
                }    
            }
        }    
    }

    onTyreChangeTextChange(index,field,e) {
        let {tyreChange} = this.state
        let value = field==='tyre_mileage'?e:e.target.value
        tyreChange[index][field] = value
        this.setState({tyreChange:tyreChange})
        let item = {index:tyreChange[index].wheel_at,field:field,value:value}
        this.props.onTyreChangeTextChange(item)
    }

    onTyreRepairTextChange(index,field,e) {
        let {tyreRepair} = this.state
        tyreRepair[index][field] = e.target.value
        this.setState({tyreRepair:tyreRepair})
        let item = {index:tyreRepair[index].wheel_at,field:field,value:e.target.value}
        this.props.onTyreRepairTextChange(item)
    }
    
    onTyreChangeCheck(index,value) {
        let {tyreChange} = this.state
        tyreChange[index]['is_new'] = value
        this.setState({tyreChange:tyreChange})
        let item = {index:tyreChange[index].wheel_at,field:'is_new',value:value}
        this.props.onTyreChangeTextChange(item)
    }

    onTyreChangeDelClick(index,wheel_at) {
        let {tyreChange,stocklist} = this.state
        tyreChange.splice(index,1)
        stocklist.splice(index,1)
        this.setState({tyreChange:tyreChange,stocklist:stocklist})
        this.props.onTyreChangeDel(wheel_at)
    }

    onTyreRepairDelClick(index,wheel_at) {
        let {tyreRepair} = this.state
        tyreRepair.splice(index,1)
        this.setState({tyreRepair:tyreRepair})
        this.props.onTyreRepairDel(wheel_at)
    }

    onFormChange(field,e) {
        let {form} = this.state
        form[field] = field==='tyre_mileage'?e:e.target.value
        this.setState({form:form})
    }

    onFormDateChange(e) {
        let {form} = this.state
        form.record_date = e
        this.setState({form:form})
    }

    onFormTimeChange(e) {
        let {form} = this.state
        form.record_time = e
        this.setState({form:form})
    }

    onNomalMode() {
        this.setState({record_id:undefined,showCancelConfirm:false,tyreChangeActiveKey:0,isView:false,form:{record_date:TODAY,record_time:TIME,description:'',request_by:'',response_by:'',tyre_mileage:''}})
        this.props.normalMode()
    }

    onTreadDepthChange(index,field,e) {
        let {treaddepth} = this.state
        let value = field==='treaddepth'?e:e.target.value
        treaddepth[index][field] = value
        this.setState({treaddepth:treaddepth})
        let item = {index:treaddepth[index].wheel_at,field:field,value:value}
        this.props.onTreadDepthChange(item)
    }

    onTreadDepthDel(index,wheel_at) {
        let {treaddepth} = this.state
        treaddepth.splice(index,1)
        this.setState({treaddepth:treaddepth})
        this.props.onTreadDepthDel(wheel_at)
    }

    onPrintClick() {
        let {tyreChangeActiveKey,record_id} = this.state
        let url = 'PrintReportAssetVehicle&mode='+tyreChangeActiveKey+'&rId='+record_id
        if (process.env.NODE_ENV === "development") {
            url  = './?startPage='+url
        } else{
            url = './pdf/v2/?startPage='+url
        }
        this._iframe.getWrappedInstance().loadUrl(url)
    }

    renderViewRowData() {
        let {tyreSwap} = this.state
        if (tyreSwap.length===0) {
            return(<tr key={0}><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                tyreSwap.map((item,index)=>{
                    return(
                            <tr key={index}>
                                <td className='text-center'>{item.from_wheel_at}</td>
                                <td className='text-center'>{item.serial_no}</td> 
                                <td className='text-center'>{item.is_new==='1'?'ใหม่':item.is_new==='0'?'เก่า':''}</td>
                                <td className='text-center'>{item.from_wheel_at}</td>
                                <td className='text-center'>{item.serial_no}</td> 
                                <td className='text-center'>{item.is_new==='1'?'ใหม่':item.is_new==='0'?'เก่า':''}</td>
                            </tr>
                    )
                })    
            )    
        }
    }

    renderRowData() {
        let {partPositions} = this.props
        let {data} = this.state
        let key = partPositions.findIndex(x=>x.new_position!==false)
        if (key===-1) {
            return(<tr key={0}><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                partPositions.reduce((rresult,item,index)=>{
                    let detail = data.find((fitem,findex)=>{
                        return item.label===fitem.wheel_at
                    })
                    let detailNew = data.find((fitem,findex)=>{
                        return item.new_position===fitem.wheel_at
                    })
                    if(item.new_position){
                        rresult.push((
                            <tr key={index}>
                                <td className='text-center'>{item.label}</td>
                                <td className='text-center'>{detail!==undefined?detail.serial_no:''}</td> 
                                <td className='text-center'>{detail===undefined?'':detail!==undefined&&detail.is_new==='1'?'ใหม่':detail!==undefined&&detail.is_new==='0'?'เก่า':''}</td>
                                {/* <td className='text-center'>{item.new_position}</td>
                                <td className='text-center'>{detailNew!==undefined?detailNew.tyre_code:''}</td> 
                                <td className='text-center'>{detailNew===undefined?'':detailNew!==undefined&&detailNew.is_new==='1'?'ใหม่':detailNew!==undefined&&detailNew.is_new==='0'?'เก่า':''}</td> */}
                                <td className='text-center'>{item.label}</td>
                                <td className='text-center'>{detailNew!==undefined?detailNew.serial_no:''}</td> 
                                <td className='text-center'>{detailNew===undefined?'':detailNew!==undefined&&detailNew.is_new==='1'?'ใหม่':detail!==undefined&&detail.is_new==='0'?'เก่า':''}</td>
                            </tr>
                        ))
                    }
                    return rresult
                },[])
            )    
        }
    }

    renderPartPositionTable(){
        let {isView} = this.state
        return (
            <div className='table-responsive'>
                <table className='table table-bordered-solid table-hover'>
                    <thead>
                        <tr>
                            <th colSpan={3} className='text-center'>ตำแหน่งล้อเดิม</th>
                            <th colSpan={3} className='text-center'>ตำแหน่งล้อปัจจุบัน</th>
                        </tr>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ล้อที่</th>
                            <th style={{width:'150px'}} className='text-center'>หมายเลขยาง</th>
                            <th style={{width:'100px'}} className='text-center'>สภาพยาง</th>
                            <th style={{width:'50px'}} className='text-center'>ล้อที่</th>
                            <th style={{width:'150px'}} className='text-center'>หมายเลขยาง</th>
                            <th style={{width:'100px'}} className='text-center'>สภาพยาง</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!isView?this.renderRowData():this.renderViewRowData()}
                    </tbody>
                </table>
            </div>
        )        
    }

    renderTyreRepairRowData() {
        let {tyreRepair,isView,valid} = this.state
        if (tyreRepair.length===0) {
            return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                tyreRepair.map((item,index)=>{
                    let isValid = valid.repair.indexOf(index)
                    return(
                        <tr key={index}>
                            <td className='text-center'><div style={{display:'inline-block'}} className='damage-spot-circle'>{item.wheel_at}</div></td>
                            <td className='text-center'>
                                <FormControl style={{borderColor:(isValid!==-1?'#dd4b39':'#ccc')}} disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'serial_no')} value={item.serial_no} />
                            </td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'tyre_brand')} value={item.tyre_brand} /></td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'tyre_model')} value={item.tyre_model} /></td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'tyre_size')} value={item.tyre_size} /></td>
                            <td className='text-center'>
                                <FormControl disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'description')} value={item.description} />
                            </td>
                            <td className='text-center'>
                                <FormControl disabled={isView} onChange={this.onTyreRepairTextChange.bind(this,index,'shop_name')} value={item.shop_name} />
                            </td>
                            <td className='text-center'>
                                <Button disabled={isView} bsStyle='danger' onClick={this.onTyreRepairDelClick.bind(this,index,item.wheel_at)}><FontAwesome name='eraser' /></Button>
                            </td>
                        </tr>    
                    )
                })
            )
        }
    }

    renderTyreChangeRowData() {
        let {tyreChange,isView,valid} = this.state
        if (tyreChange.length===0) {
            return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                tyreChange.map((item,index)=>{
                    let isValid = valid.change.indexOf(index)
                    return(
                        <tr key={index}>
                            <td className='text-center'><div style={{display:'inline-block'}} className='damage-spot-circle'>{item.wheel_at}</div></td>
                            <td className='text-center'>
                                <FormControl 
                                    style={{borderColor:(isValid!==-1?'#dd4b39':'#ccc')}}
                                    disabled={isView} 
                                    onChange={this.onTyreChangeTextChange.bind(this,index,'serial_no')} 
                                    value={item.serial_no} 
                                />
                            </td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreChangeTextChange.bind(this,index,'tyre_brand')} value={item.tyre_brand} /></td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreChangeTextChange.bind(this,index,'tyre_model')} value={item.tyre_model} /></td>
                            <td className='text-center'>
                                <Radio
                                    disabled={isView}
                                    onChange={this.onTyreChangeCheck.bind(this,index,'1')}
                                    checked={item.is_new==='1'?true:false}
                                    radioClass="iradio_square-blue"
                                    increaseArea="20%"
                                    label=" ใหม่"
                                >
                                </Radio>  
                                {' '}
                                <Radio
                                    disabled={isView}
                                    onChange={this.onTyreChangeCheck.bind(this,index,'0')}
                                    checked={item.is_new==='0'?true:false}
                                    radioClass="iradio_square-blue"
                                    increaseArea="20%"
                                    label=" เก่า"
                                >
                                </Radio>
                            </td>
                            <td className='text-center'><FormControl disabled={isView} onChange={this.onTyreChangeTextChange.bind(this,index,'tyre_size')} value={item.tyre_size} /></td>
                            <td className='text-center'>
                                <InputNumber
                                    disabled={isView}
                                    className='input-number-format-form-control text-center'
                                    value={item.tyre_mileage} 
                                    onChange={this.onTyreChangeTextChange.bind(this,index,'tyre_mileage')}
                                    formatter={value =>
                                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                    }
                                />
                            </td>
                            <td className='text-center'>
                                <Button disabled={isView} bsStyle='danger' onClick={this.onTyreChangeDelClick.bind(this,index,item.wheel_at)}><FontAwesome name='eraser' /></Button>
                            </td>
                        </tr>    
                    )
                })
            )
        }    
    }

    renderTyreRepairTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-bordered-solid table-hover'>
                    <thead>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ตำแหน่งล้อ</th>
                            <th style={{width:'100px'}} className='text-center'>หมายเลขยาง <span className='text-red'>*</span></th>
                            <th style={{width:'100px'}} className='text-center'>ยี่ห้อ</th>                            
                            <th style={{width:'100px'}} className='text-center'>รุ่น</th>                            
                            <th style={{width:'80px'}} className='text-center'>ขนาดยาง</th>
                            <th style={{width:'150px'}} className='text-center'>รายการซ่อม</th>
                            <th style={{width:'100px'}} className='text-center'>ร้านซ่อม</th>
                            <th style={{width:'50px'}} className='text-center'>ลบ ?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderTyreRepairRowData()}
                    </tbody>    
                </table>
            </div>
        )
    }

    renderTyreChangeTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-bordered-solid table-hover'>
                    <thead>
                        <tr>
                            <th style={{width:'50px'}} className='text-center'>ตำแหน่งล้อ</th>
                            <th style={{width:'100px'}} className='text-center'>หมายเลขยาง <span className='text-red'>*</span></th>
                            <th style={{width:'100px'}} className='text-center'>ยี่ห้อ</th>                            
                            <th style={{width:'100px'}} className='text-center'>รุ่น</th>                            
                            <th style={{width:'100px'}} className='text-center'>ชนิดยาง</th>
                            <th style={{width:'80px'}} className='text-center'>ขนาดยาง</th>
                            <th style={{width:'90px'}} className='text-center'>เลขไมค์ยาง (ถ้ามี)</th>
                            <th style={{width:'50px'}} className='text-center'>ลบ ?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderTyreChangeRowData()}
                    </tbody>    
                </table>
            </div>
        )
    }

    renderTreadDepthRowData() {
        let {treaddepth,isView,valid} = this.state
        if (treaddepth.length===0) {
            return(<tr><td colSpan={7}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                treaddepth.map((item,index)=>{
                    let isValid = valid.depth.indexOf(index)
                    return(
                            <tr key={index}>
                                <td className='text-center'>{item.wheel_at}</td>
                                <td className='text-center'>
                                    <FormControl style={{borderColor:(isValid!==-1?'#dd4b39':'#ccc')}} disabled={isView} value={item.serial_no} onChange={this.onTreadDepthChange.bind(this,index,'serial_no')} />
                                </td>
                                <td className='text-center'><FormControl disabled={isView} value={item.tyre_brand} onChange={this.onTreadDepthChange.bind(this,index,'tyre_brand')} /></td>
                                <td className='text-center'><FormControl disabled={isView} value={item.tyre_model} onChange={this.onTreadDepthChange.bind(this,index,'tyre_model')} /></td>
                                <td className='text-center'>
                                    <FormControl disabled={isView} value={item.tyre_size} onChange={this.onTreadDepthChange.bind(this,index,'tyre_size')} />
                                </td>
                                <td className='text-center'>
                                    <InputNumber
                                        disabled={isView}
                                        className='input-number-format-form-control text-center'
                                        value={item.treaddepth} 
                                        onChange={this.onTreadDepthChange.bind(this,index,'treaddepth')}
                                        formatter={value =>
                                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        }
                                    />
                                </td>
                                <td className='text-center'><Button disabled={isView} bsStyle='danger' onClick={this.onTreadDepthDel.bind(this,index,item.wheel_at)}><FontAwesome name='eraser' /></Button></td>
                            </tr>
                    )
                })    
            )
        }
    }

    renderTreadDepthTable() {
        return(
            <div className='table-responsive'>
                <table className='table table-bordered-solid table-hover'>
                    <thead>
                        <tr>
                            <th style={{width:'100px'}} className='text-center'>ล้อที่</th>
                            <th style={{width:'100px'}} className='text-center'>หมายเลขยาง <span className='text-red'>*</span></th>
                            <th style={{width:'100px'}} className='text-center'>ยี่ห้อ</th>
                            <th style={{width:'100px'}} className='text-center'>รุ่น</th>
                            <th style={{width:'100px'}} className='text-center'>ขนาดยาง</th>
                            <th style={{width:'100px'}} className='text-center'>ความลึกดอกยาง (มม.)</th>
                            <th style={{width:'50px'}} className='text-center'>ลบ ?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderTreadDepthRowData()}
                    </tbody>    
                </table>
            </div>
        )
    }

    renderForm(field) {
        let {form,isView,valid_date} = this.state
        return(
            <div>
                <Form>
                    <FormGroup className='row'>
                        <Col md={2}>
                            วันที่
                        </Col>
                        <Col md={4}>
                            <DatePicker
                                formGMargin0={true}
                                inline={false}
                                isError={valid_date}
                                disabled={isView}
                                maxWidth={'100%'}
                                showIcon={true}
                                showFooter={true}
                                popPlacement='bottom'
                                buddhistEra
                                value={form.record_date}
                                onChange={this.onFormDateChange.bind(this)}
                            />
                        </Col>
                        <Col md={2}>
                            เวลา
                        </Col>
                        <Col md={4}>
                            <CkTimePicker
                                disabled={isView}
                                maxWidth={'100%'}
                                showIcon={true}
                                inline={false}
                                value={form.record_time}
                                minuteStep={5}
                                onTimeSaved={this.onFormTimeChange.bind(this)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup className='row'>
                        <Col md={2}>
                            {field==='0'?'ผู้ขอสลับยาง':field==='1'?'ผู้ขอเปลี่ยนยาง':'ผู้ดำเนินการ'}
                        </Col>
                        <Col md={4}>
                            <FormControl disabled={isView} value={form.request_by} onChange={this.onFormChange.bind(this,'request_by')} />
                        </Col>
                        <Col md={2}>
                            ผู้อนุมัติ
                        </Col>
                        <Col md={4}>
                            <FormControl disabled={isView} value={form.response_by} onChange={this.onFormChange.bind(this,'response_by')} />
                        </Col>
                    </FormGroup>   
                    <FormGroup className='row'>
                        <Col md={2}>
                            เลขไมล์/กม.
                        </Col>
                        <Col md={4}>
                            <InputNumber
                                disabled={isView}
                                className='input-number-format-form-control text-left'
                                value={form.tyre_mileage} 
                                onChange={this.onFormChange.bind(this,'tyre_mileage')}
                                formatter={value =>
                                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            />
                        </Col>
                        <Col md={2}>
                            คำอธิบาย
                        </Col>
                        <Col md={4}>
                            <FormControl disabled={isView} value={form.description} onChange={this.onFormChange.bind(this,'description')} />
                        </Col>
                    </FormGroup>    
                </Form>    
            </div>   
        )
    }

    renderOptionBtn() {
        return(
            [<Button onClick={this.onStocklistClick.bind(this,true)} bsStyle='primary' style={{minWidth:'80px'}}><FontAwesome name={'check'} />&nbsp;ใช่</Button>,
            <Button onClick={this.onStocklistClick.bind(this,false)} bsStyle='danger' style={{minWidth:'80px'}}><FontAwesome name={'ban'} />&nbsp;ไม่</Button>]
        )
    }

    render(){
        const {tyreChangeActiveKey,isView} = this.state
        let {menu,mode} = this.props
        let bs = (<span>&nbsp;</span>)
        return (
            <div>
                <Tabs 
                    id='tabs-sum-asset-vehicle'
                    defaultActiveKey={0}
                    activeKey={tyreChangeActiveKey}
                    onSelect={(e)=>{this.setState({tyreChangeActiveKey:e})}}
                >
                    {menu==='0'
                    ?
                    <Tab 
                        key={0}
                        eventKey={0} 
                        title={'รวมสลับยาง'}
                    >
                        <Box>
                            <Box.Body>
                                {this.renderForm('0')}
                                {this.renderPartPositionTable()}
                            </Box.Body>
                        </Box>   
                    </Tab>
                    :''}
                    {menu==='1'
                    ?
                    <Tab 
                        key={1}
                        eventKey={1} 
                        title={'รวมเปลี่ยนยาง'}
                    >
                        <Box>
                            <Box.Body>
                                {this.renderForm('1')}
                                {this.renderTyreChangeTable()}
                            </Box.Body>
                        </Box>
                    </Tab>
                    :''}
                    {menu==='4'
                    ?
                    <Tab 
                        key={4}
                        eventKey={4} 
                        title={'รวมซ่อมยาง'}
                    >
                        <Box>
                            <Box.Body>
                                {this.renderForm('4')}
                                {this.renderTyreRepairTable()}
                            </Box.Body>
                        </Box>
                    </Tab>
                    :''}
                    {/* {menu==='2'
                    ?
                    <Tab 
                        key={2}
                        eventKey={2} 
                        title={'รวมหล่อดอก'}
                    >
                        {this.renderForm('1')}
                    </Tab>
                    :''} */}
                    {menu==='3'
                    ?
                    <Tab 
                        key={3}
                        eventKey={3} 
                        title={'รวมวัดดอกยาง'}
                    >
                        <Box>
                            <Box.Body>
                                {this.renderForm('3')}
                                {this.renderTreadDepthTable()}
                            </Box.Body>
                        </Box>        
                    </Tab>
                    :''}
                </Tabs>
                <div style={{float:'right',position:'absolute',right:'10px'}}>
                    {!isView?<Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save'/> บันทึกข้อมูล</Button>:''}
                    &nbsp;
                    {isView?<Button className='bg-maroon' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร</Button>:''}
                    {isView?bs:''}
                    {!isView
                    ?
                    <Button onClick={()=>{this.setState({showCancelConfirm:true})}}><FontAwesome name='close'/>&nbsp;{'ยกเลิก'+mode}</Button>
                    :
                    <Button onClick={this.onNomalMode.bind(this)}><FontAwesome name='table'/>&nbsp;กลับหน้าตารางหลัก</Button>
                    }
                </div>    
                <NotificationSystem ref="notificationSystem" />      
                <IframeModal ref='iframe' title='พิมพ์เอกสาร'/>
                <ConfirmPopup
                    show={this.state.showConfirm}
                    message={'ต้องการทำรายการบันทึกข้อมูล ?'}
                    onConfirm={this.onOperationSave.bind(this)}
                    onHide={()=>{this.setState({showConfirm:false,isStocklist:false})}}
                />
                <ConfirmPopup
                    show={this.state.showChangeConfirm}
                    message={'ต้องการนำยางที่ถอดจากล้อเข้าระบบคลังยางหรือไม่ ?'}
                    renderOptionBtn={this.renderOptionBtn.bind(this)}
                    onHide={()=>{this.setState({showChangeConfirm:false})}}
                />
                <ConfirmPopup
                    show={this.state.showCancelConfirm}
                    message={'ต้องการกลับหน้าตารางหลัก ?'}
                    onConfirm={this.onNomalMode.bind(this)}
                    onHide={()=>{this.setState({showCancelConfirm:false})}}
                />
            </div>
        )
    }
}

AssetVehicleOperation.defaultProps = {
    partPositions:[],
    mode:'สลับยาง'
}

export default AssetVehicleOperation;



// WEBPACK FOOTER //
// ./src/view/tyre/AssetVehicleOperation.js